<template>
<div class="flex-column flex">
    <div v-for="comm in this.communications" v-bind:key="comm.id" class="flex flex-wrap mb-2"
         :class="`${comm.received ? 'justify-content-start' : 'justify-content-end' }`">
        <DetailMessage  :internal="this.internal" :message="comm" :communication="true"></DetailMessage>
    </div>
</div>
</template>

<script lang="ts">
import Security from './security'
import {store} from './store'
import DetailMessage from '@/components/DetailMessage.vue';
import notie from "notie/dist/notie";
import {emiter} from '../main';

export default {
    name: 'CommunicationList',
    components: {
        DetailMessage,
        //PrimevueButton,
    },
    props: [
       "internal",
       "orderId",
       
       ],
    data() {
        return {
            store,
            communications : [],
            filters:{ global: "",
                      table:"",
                      globalFilterFields: [],
                      filterFields: [],
                    },

        }
    },
 
    beforeMount() {

      if(Security.requireToken()){
        store.selectModul = this.$route.path.split("/")[1]
        this.fetchData();
        emiter.on('newEmail',this.fetchData);
      }
    },
    
    methods: {
      fetchData(){
        if(this.internal){
          this.filters.table = "message_int"
        }else{
          this.filters.table = "message"
        
        }
      
        fetch(store.Api_url + store.basicUrlFilterCommunication + ",order_id:" + this.orderId , Security.requestOptions("POST",this.filters))
              .then((response) => response.json())
              .then((responseData) => {
                if (responseData.error) {
                  //console.log("error:", responseData.message);
                  notie.alert({
                    type: 'error',
                    text: 'Nepodarilo sa načítať zoznam správ',
                    position: "bottom"
                  })          
                } else {
                  
                  if(responseData.data != null){
                    this.communications = responseData.data;
                    if(!this.internal){
                      emiter.emit('reload');
                    }
                    //console.log("Communications: ",responseData)
                  } else{
                    //console.log("Communications: ",responseData)
                    this.communications = []

                  }
    
  
                }
        });
      }
    },


    beforeUnmount(){
      emiter.off('newEmail',this.fetchData);
    },  
}    
</script>